import { z } from 'zod/v4';

import {
  DifficultyLevelSchema,
  ElementSchema,
  QliphahNameSchema,
  SephirahNameSchema,
  SpreadCategorySchema,
} from './tarot.schema';

export const SpreadPositionSchema = z.object({
  index: z.number().int().nonnegative(),
  name: z.string().min(1),
  description: z.string().min(1),
  sephirah_correspondence: SephirahNameSchema.nullable(),
  qliphah_correspondence: QliphahNameSchema.nullable(),
  element_affinity: ElementSchema.nullable(),
  x: z.number(),
  y: z.number(),
  z: z.number(),
});

export const SpreadSchema = z
  .object({
    id: z.string().min(1),
    name: z.string().min(1),
    slug: z.string().min(1),
    category: SpreadCategorySchema,
    cards: z.number().int().positive(),
    positions: z.array(SpreadPositionSchema),
    is_lilith: z.boolean(),
    description: z.string().min(1),
    ritual_note: z.string().min(1).nullable(),
    opening_invocation: z.string().min(1).nullable(),
    closing_words: z.string().min(1).nullable(),
    difficulty: DifficultyLevelSchema,
    tree_of_life_mapping: z.boolean(),
  })
  .refine((value) => value.positions.length === value.cards, {
    message: 'Spread.positions length must match Spread.cards.',
    path: ['positions'],
  });

export const SpreadJsonSchema = z.toJSONSchema(SpreadSchema);
